import moment from "moment/moment";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

const formatToCurrencyType = (currency) => {
  return currency || currency == 0
    ? Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }).format(currency)
    : "";
};
const formatDateToString = (date, format = "YYYY-MM-DD") => {
  const validDate = moment(date?.toString()).isValid();
  return date && validDate
    ? moment(date?.toString()).format(format)
    : undefined;
};

const isDraftEmpty = (es) => {
  const content = es.getCurrentContent();
  if (!content.hasText()) return true;
  const raw = convertToRaw(content);
  return raw.blocks.every((b) => b.text.trim() === "");
};

const toHtmlOrEmpty = (es) => {
  if (!es) return ""; // phòng an toàn
  return isDraftEmpty(es)
    ? ""
    : draftToHtml(convertToRaw(es.getCurrentContent())).trim();
};

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

// chuyển base64 về dạng chuẩn để hiển thị và upload
const normalizeBase64 = (base64) => {
  if (!base64) return "";
  return base64.startsWith("data:image")
    ? base64
    : `data:image/jpeg;base64,${base64}`;
};
const base64ToFile = (base64, filename) => {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
const base64ListToFileList = (base64List) => {
  return base64List.map((base64, index) => {
    const normalized = normalizeBase64(base64);
    const file = base64ToFile(normalized, `image-${index + 1}.jpg`);

    return {
      uid: `base64-${index}`,
      name: file.name,
      status: "done",
      url: normalized, // để hiển thị
      thumbUrl: normalized, // chắc chắn preview
      originFileObj: file, // ⭐ quan trọng: giống file upload
      type: file.type,
      size: file.size,
      lastModified: file.lastModified,
    };
  });
};

export {
  formatToCurrencyType,
  formatDateToString,
  toHtmlOrEmpty,
  fileToBase64,
  base64ListToFileList,
};
